import Link from 'next/link'
import React from 'react'
import { Box, useMultiStyleConfig } from '@chakra-ui/react'
import { BannerBackgroundImage } from '~/components/search-and-results/FlightAviosOnlyBanner/BannerBackgroundImage'
import { SoldOutRibbon } from '~/components/search-and-results/FlightAviosOnlyBanner/SoldOutRibbon'
import { useFeatureFlag } from '~/context/featureFlag'
import { useAviosOnlyPromotion } from '~/hooks/useAviosOnlyPromotion/useAviosOnlyPromotion'
import { pushEventToDataLayer } from '~/utils/googleTagManager'
import { BannerContent } from './BannerContent'

function trackCtaClick() {
  pushEventToDataLayer('navigation', {
    nav_type: 'cta',
    nav_action: 'avios-only reward flights book now',
  })
}

const FlightAviosOnlyBanner = () => {
  const styles = useMultiStyleConfig('FlightAviosOnlyBanner', {})

  const { aviosOnlyPromotionContent, isLoading } = useAviosOnlyPromotion()
  const aviosOnlySeatsAvailable = useFeatureFlag('flights-avios-only-seats-still-available')

  if (!aviosOnlyPromotionContent || isLoading) {
    return null
  }

  const {
    introduction,
    title,
    outboundDate,
    inboundDate,
    fromAirportCode,
    toAirportCode,
    image,
    soldOutImage,
  } = aviosOnlyPromotionContent

  const backgroundImageUrl = aviosOnlySeatsAvailable ? image.file?.url : soldOutImage.file?.url

  return (
    <Box sx={styles.aviosOnlyBanner} data-testid="flight-avios-only-banner">
      <BannerBackgroundImage url={backgroundImageUrl as string} />

      {aviosOnlySeatsAvailable ? (
        <Link
          title={`${introduction} ${title}`}
          onClick={trackCtaClick}
          prefetch={false}
          shallow
          href={{
            query: {
              tab: 'flights',
              departureDate: outboundDate,
              returnDate: inboundDate,
              fromAirportCode,
              toAirportCode,
              oneWayOnly: false,
            },
          }}
          data-testid="flight-avios-only-cta"
        >
          <BannerContent
            aviosOnlyPromotionContent={aviosOnlyPromotionContent}
            aviosOnlySeatsAvailable={aviosOnlySeatsAvailable}
          />
        </Link>
      ) : (
        <>
          <BannerContent
            aviosOnlyPromotionContent={aviosOnlyPromotionContent}
            aviosOnlySeatsAvailable={aviosOnlySeatsAvailable}
          />
          {!aviosOnlySeatsAvailable && <SoldOutRibbon />}
        </>
      )}
    </Box>
  )
}

export default FlightAviosOnlyBanner
